import React, { useState } from "react";
import HTMLFlipBook from "react-pageflip";
import pdfFile from "../../../src/Img/SPN.pdf";
import "../flip/Flipbook.scss";
import { Document, Page, pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const Pages = React.forwardRef((props, ref) => {
  return (
    <div className="demoPage" ref={ref}>
      <p>{props.children}</p>
      <p>Page number: {props.number}</p>
    </div>
  );
});

Pages.displayName = "Pages";

function Flipbook() {
  const [numPages, setNumPages] = useState(1);
  const [isOpen, setIsOpen] = useState(false); // State to track if the book is opened
  const flipbookRef = React.useRef(); // Ref for the flipbook

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  function handlePageFlip() {
    setIsOpen(true); // Set to true when a page is flipped
  }

  const goToNextPage = () => {
    if (flipbookRef.current) {
      flipbookRef.current.pageFlip().flipNext();
    }
  };

  const goToPrevPage = () => {
    if (flipbookRef.current) {
      flipbookRef.current.pageFlip().flipPrev();
    }
  };

  return (
    <div className={`flipbook-container ${isOpen ? "open" : ""}`}>
      <h1 className="flipbook-heading">जाहीरनामा</h1> {/* Added heading */}
      <HTMLFlipBook
        ref={flipbookRef} // Attach ref to the flipbook
        width={500}
        height={600}
        onFlip={handlePageFlip} // Trigger the animation when the page is flipped
        mobileScrollSupport={true} // Enabling mobile scroll
      >
        {[...Array(numPages).keys()].map((pg) => (
          <Pages key={pg} number={pg + 1}>
            <Document file={pdfFile} onLoadSuccess={onDocumentLoadSuccess}>
              <Page pageNumber={pg + 1} width={500} />
            </Document>
          </Pages>
        ))}
      </HTMLFlipBook>
      <div className="flipbook-controls">
        <button className="flipbook-arrow left" onClick={goToPrevPage}>
          &#8249; {/* Left arrow */}
        </button>
        <button className="flipbook-arrow right" onClick={goToNextPage}>
          &#8250; {/* Right arrow */}
        </button>
      </div>
    </div>
  );
}

export default Flipbook;
